import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskPracticesResource } from '@jira/router-resources__service-desk-practices/src/useWorkCategoriesAllSupported.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsServicedeskItsmTicketTypeFieldsRoute } from '@jira/router-routes__project-settings-service-desk-ticket-type-fields-routes/src/projectSettingsServicedeskItsmTicketTypeFieldsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskTicketTypeFields, {
	LazyProjectSettingsServiceDeskTicketTypeFields,
} from './ui/service-desk-ticket-type-fields/index.tsx';

export const projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry: Route = createEntry(
	projectSettingsServicedeskItsmTicketTypeFieldsRoute,
	() => ({
		group: 'project-settings-servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskTicketTypeFields,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			servicedeskPracticesResource,
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskTicketTypeFields],

		meta: {
			reporting: {
				id: APP_NAMES.REQUEST_TYPE_FIELDS,
				packageName: toPackageName(APP_NAMES.REQUEST_TYPE_FIELDS),
				teamName: 'jsd-shield',
			},
		},

		ufoName: 'project-settings-servicedesk-ticket-type-fields',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
